import Bugsnag from "@bugsnag/js";
import BugsnagPerformance from "@bugsnag/browser-performance";
import { UAParser } from "ua-parser-js";
import { ApiError } from "./Error/ApiErrors";

// Transient gateway/network failures: 502/503/504 are upstream/infra hiccups and
// 0 is an aborted/offline request — none are actionable application bugs.
const TRANSIENT_API_STATUSES = [0, 502, 503, 504];

function InitBugsnag(): void {
  const appEnv = $("#app-env").data("appEnv") as string;

  // This will be of limited use outside of Android and Chromebook (Microsoft and Apple don't include device info in the UA),
  // but is included here in case it's useful.
  const device = new UAParser().getDevice();

  Bugsnag.start({
    apiKey: BUGSNAG_JS_API_KEY,
    appVersion: VERSION,

    collectUserIp: false,
    releaseStage: appEnv,
    metadata: { deviceInfo: device },

    // The inline-script plugin wraps every event handler, timer and rAF callback on the page to
    // attribute errors to inline <script> blocks. Game pages run a per-frame rAF loop and a
    // mousemove stream that already saturate slow school hardware, and profiling shows the wrapper
    // taking half of those tasks — so game pages give it up where real users pay for it. Local and
    // dev keep full tracing everywhere: debugging wants the attribution, and profiling there should
    // still expose the wrapper it ships. Bundle errors keep full stacktraces either way.
    trackInlineScripts: !(
      document.getElementById("game-container") !== null &&
      (appEnv === "staging" || appEnv === "production")
    ),

    onError: function (event) {
      // If we're not in production mode, we don't return our errors
      if (appEnv === "local") {
        return false;
      }

      // Don't report transient gateway/network failures — they're infra noise.
      const error: unknown = event.originalError;
      if (
        error instanceof ApiError &&
        TRANSIENT_API_STATUSES.includes(error.status)
      ) {
        return false;
      }

      return true;
    },
  });

  const userEl = $("#bugsnag-user");
  if (userEl.length) {
    Bugsnag.setUser(
      String(userEl.data("userId")),
      userEl.data("userEmail") as string,
      userEl.data("userType") as string,
    );
  }

  BugsnagPerformance.start({
    apiKey: BUGSNAG_JS_API_KEY,
    appVersion: VERSION,
    releaseStage: appEnv,
  });
}
export default InitBugsnag;
